<h2>
  Faza 1
</h2>
<div
  fxLayout="column"
  fxLayout.gt-sm="row"
  fxLayoutAlign="center center"
  class="container images-container"
>
  <app-images-carousel-base
    [images]="images1"
    class="images-slider"
  >
  </app-images-carousel-base>
</div>

<h2>
  Faza 2
</h2>
<div
  fxLayout="column"
  fxLayout.gt-sm="row"
  fxLayoutAlign="center center"
  class="container images-container"
>
  <app-images-carousel-base
    [images]="images2"
    class="images-slider"
  >
  </app-images-carousel-base>
</div>

<h2>
  Faza 3
</h2>
<div
  fxLayout="column"
  fxLayout.gt-sm="row"
  fxLayoutAlign="center center"
  class="container images-container"
>
  <app-images-carousel-base
    [images]="images3"
    class="images-slider"
  >
  </app-images-carousel-base>
</div>

<div class="container">
  <div
    fxLayout="row wrap"
    fxLayoutAlign="center center"
    class="images-list page-section"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      *ngFor="let video of videos; trackBy: listTrackingService.disableUpdate"
      class="gallery-item full-width"
      [class.full-width]="currentYear == 2018"
    >
      <div
        class="video"
        [innerHtml]="video"
      >
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/downtown-life/construction.component.html